import { ROUTE_PATH } from 'modules/routes/constants/index.cjs'
import interpolateRouteUtil from 'modules/routes/utils/interpolate'
import Workout from 'pages/Workout/components/Workout'
import React from 'react'
import { logUtil } from 'packages/src'

export default function WorkoutPage (props) {
  const {
    id,
    slug
  } = props.match.params
  const startWorkoutLink = interpolateRouteUtil(ROUTE_PATH.START_WORKOUT, {
    id,
    slug
  })

  const debugProps = {
    id,
    slug,
    startWorkoutLink,
    ...props
  }
  logUtil('WorkoutPage').debug('debugProps=', debugProps)

  return (
    <Workout
      id={id}
      isRecommended={false}
      startWorkoutLink={startWorkoutLink}
      {...props}
    />
  )
}
